import { styled } from "styled-components";

import {
    BackgroundField,
    BackgroundFieldValue,
    Breakpoint,
    cssColorsFromBackgroundField,
    generateFieldsStyles,
    minWidth,
    scrollMargin
} from "../../styles";

type SectionProps = {
    sectionBackground?: BackgroundField[];
    background?: BackgroundFieldValue;
    overflowingBreakpoints: Breakpoint[];
};

export const Section = styled.section<SectionProps>(
    ({ background, sectionBackground }) =>
        sectionBackground
            ? generateFieldsStyles(sectionBackground)
            : background && (background.color || background.gradient)
            ? cssColorsFromBackgroundField(background)
            : "",
    ({ overflowingBreakpoints }) =>
        generateOverflowMediaQueries(overflowingBreakpoints),
    {
        scrollMarginTop: `${scrollMargin.top}px`
    }
);

//for each breakpoint that is overflowing, generate a media query to hide x-overflow
function generateOverflowMediaQueries(overflowingBreakpoints: Breakpoint[]) {
    return overflowingBreakpoints
        .map((breakpoint) =>
            breakpoint === "xs"
                ? `overflow-x: hidden;`
                : `
        @media ${minWidth[breakpoint]} {
          overflow-x: hidden;
        }
      `
        )
        .join("");
}
